import { t } from 'ember-intl';
import { VStack } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import pageTitle from 'ember-page-title/helpers/page-title';

<template>
  {{pageTitle (t "idr.default")}}
  <VStack>
    <PageHeader @title={{t "idr.default"}} />
    {{outlet}}
  </VStack>
</template>
